const tableHeaders = {
  Property: [
    "InquiresId",
    "PropertyId",
    "Status",
    "UserName",
    "PhoneNumber",
    "Email",
    "InquiryStatus",
    "Done",
    "CreatedDate",
    "Actions",
  ],
  Car: [
    "InquiresId",
    "CardId",
    "UserName",
    "PhoneNumber",
    "Email",
    "InquiryStatus",
    "Done",
    "CreatedDate",
    "Actions",
  ],
  Other: [
    "InquiresId",
    "PropertyId",
    "CardId",
    // "Status",
    "UserName",
    "PhoneNumber",
    "Email",
    "InquiryStatus",
    "Done",
    "CreatedDate",
    "Actions",
  ],
  Product: [
    "srNo",
    "productCode",
    "productId",
    "category",
    "marketingCategory",
    "productTitle",
    "productDescription",
    "price",
    "quantity",
    "businessName",
    "createBy",
    "createdDate",
    "updatedBy",
    "updatedDate",
    "Actions",
  ],
  // You can add more categories here
  ListingsProperty: [
    "Code",
    "PropertyId",
    "Title",
    "Status",
    "Type",
    "Location",
    "Price",
    "Furnished",
    // "Special Status",
    "NumberOfViewers",
    // "Availability",
    // "Sold/Rented",
    "Actions",
  ],
  ListingsCar: [
    "Code",
    "CarId",
    "Status",
    "Title",
    "Gearbox",
    "Manufacturer",
    "Model",
    "Year",
    "FuelType",
    "Condition",
    "Price",
    "SteeringPosition",
    "CarColor",
    // "Special Status",
    "NumberOfViewers",
    "Availability",
    // "Sold",
    "Actions",
  ],
  Account: [
    "user_Id",
    "userName",
    "userRole",
    "email",
    "phoneNumber",
    "township",
    "address",    
    "Actions",
  ],
  OrderSummary: [
    "orderId",
    "totalOrderedItem",
    "unit",
    "totalQuantity",
    "amount",
    "orderDate",
    "orderStatus",
    "paymentMethod",
    "Actions",
  ],
  PromoCode: [
    "id",
    "promotionCode",
    "title",
    "discountAmount",
    "startDate",
    "expireDate",
    "Actions",
  ],
};

export default tableHeaders;
